import { BrowserRouter } from "react-router-dom";

import { useSessionMonitor } from "./features/documents/coord/useSessionMonitor";
import AppProviders from "./providers/AppProviders";
import AppRoutes from "./routes";
import { getBasename } from "./routes/basename";

// Detect the runtime basename once at module load (see routes/basename.ts) so
// the router strips whichever prefix — page-hosting or local dev — is present.
const basename = getBasename();

function App() {
  useSessionMonitor();

  return (
    <AppProviders>
      <BrowserRouter basename={basename} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  );
}

export default App;
